import Footer from "../Homepages/Footer";
import { useNavigate } from "react-router-dom";
import { BsArrowLeft, BsCalendarDate } from "react-icons/bs";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { task } from "../../reducers/userReducer";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'
import subDays from "date-fns/subDays";
import { v4 as uuidv4 } from 'uuid';

export default function EnterTodo() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [todo, setTodo] = useState("");
  const [fakeDate, setFakeDate] = useState(null);
  const [realDate, setRealDate] = useState('');
  
  const tasks = { id:uuidv4(), todo, date:realDate };
  const onSubmit = (e) => {
    e.preventDefault();
    if (todo.length > 0 && realDate.length > 0) {
      dispatch(task(tasks))
      navigate("/todos");
    }else{
      alert("Put in a Todo and a date");
    }
  };
  return (
    <div className="container px-4 px-md-5">
      <div className="heading mb-5 mt-5">
        <BsArrowLeft
          size="30px"
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/todo");
          }}
        />
        <h3 className="text-center no-wrap">My Planner</h3>
      </div>
      <div className="container px-md-5">
        <form
          className="form"
          onSubmit={(e) => {
            onSubmit(e);
          }}
        >
          <h2>What would you like to do?</h2>
          <textarea
            className="form-control textarea my-4"
            rows="3"
            placeholder="I want to..."
            value={todo}
            onChange={(e) => {
              setTodo(e.target.value);
            }}
          ></textarea>
          <h2>When do you want to perform this task?</h2>
          <div className="textjoin my-4">
            <DatePicker selected={fakeDate} 
            dateFormat="MMMM d, yyyy"
            minDate={subDays(new Date(), 0)}
            onChange={(date) => {
              const dateString = new Date(date).toDateString()
              setRealDate(dateString)
              setFakeDate(date)
            }} 
            className="textarea2" 
            placeholderText="Choose date in calender"
            /> 
            <BsCalendarDate size="30px" color="#3AB0FF"/>
          </div>
          <button className="btnSave" type="submit">
            Save
          </button>
        </form>
      </div>
      <Footer />
    </div>
  );
}
